export const DEFAULT_PARAMS = {
  length:      1.0,
  shaftGirth:  0.75,
  glansScale:  1.3,
  coronaDepth: 0.55,
  curvature:   0.15,
  taper:       0.2,
  ridges:      0.0,
  veins:       0.2,
  baseFlare:   0.45,
  colorTone:   0.2,
  roughness:   0.4,
  sssStrength: 0.45,
};

export const PRESETS = {
  realistic: {
    length: 1.0, shaftGirth: 0.75, glansScale: 1.3, coronaDepth: 0.6,
    curvature: 0.2, taper: 0.2, ridges: 0.0, veins: 0.35, baseFlare: 0.5,
    colorTone: 0.2, roughness: 0.45, sssStrength: 0.5,
  },
  classic: {
    length: 1.0, shaftGirth: 0.7, glansScale: 1.2, coronaDepth: 0.5,
    curvature: 0.0, taper: 0.1, ridges: 0.0, veins: 0.1, baseFlare: 0.4,
    colorTone: 0.5, roughness: 0.25, sssStrength: 0.35,
  },
  large: {
    length: 1.5, shaftGirth: 1.1, glansScale: 1.4, coronaDepth: 0.7,
    curvature: 0.15, taper: 0.15, ridges: 0.1, veins: 0.4, baseFlare: 0.6,
    colorTone: 0.15, roughness: 0.5, sssStrength: 0.45,
  },
  slim: {
    length: 1.2, shaftGirth: 0.45, glansScale: 1.15, coronaDepth: 0.4,
    curvature: 0.1, taper: 0.25, ridges: 0.0, veins: 0.05, baseFlare: 0.3,
    colorTone: 0.56, roughness: 0.2, sssStrength: 0.3,
  },
  fantasy: {
    length: 1.8, shaftGirth: 0.95, glansScale: 1.75, coronaDepth: 0.9,
    curvature: 0.45, taper: 0.4, ridges: 0.75, veins: 0.65, baseFlare: 0.7,
    colorTone: 0.78, roughness: 0.35, sssStrength: 0.35,
  },
};

const PARAM_RANGES = {
  length:      { min: 0.5,  max: 2.5  },
  shaftGirth:  { min: 0.3,  max: 1.5  },
  glansScale:  { min: 0.9,  max: 2.0  },
  coronaDepth: { min: 0,    max: 1.0  },
  curvature:   { min: 0,    max: 1.0  },
  taper:       { min: 0,    max: 1.0  },
  ridges:      { min: 0,    max: 1.0  },
  veins:       { min: 0,    max: 1.0  },
  baseFlare:   { min: 0,    max: 1.0  },
  colorTone:   { min: 0,    max: 1.0  },
  roughness:   { min: 0.05, max: 0.95 },
  sssStrength: { min: 0,    max: 1.0  },
};

export function sanitizeParams(raw) {
  const result = { ...DEFAULT_PARAMS };
  for (const key of Object.keys(PARAM_RANGES)) {
    const range = PARAM_RANGES[key];
    const val = parseFloat(raw?.[key]);
    if (Number.isFinite(val)) {
      result[key] = Math.min(range.max, Math.max(range.min, val));
    }
  }
  return result;
}

export function randomPreset() {
  return {
    length:      0.5 + Math.random() * 2.0,
    shaftGirth:  0.3 + Math.random() * 1.2,
    glansScale:  0.9 + Math.random() * 1.1,
    coronaDepth: Math.random(),
    curvature:   Math.random() * 0.8,
    taper:       Math.random() * 0.8,
    ridges:      Math.random() * 0.9,
    veins:       Math.random() * 0.8,
    baseFlare:   Math.random() * 0.9,
    colorTone:   Math.random(),
    roughness:   0.05 + Math.random() * 0.85,
    sssStrength: Math.random(),
  };
}
